import React from 'react';
import { motion } from 'framer-motion';
import MissionImage from '../assets/mission-image.png';
import '../styles/mission.css';

function Mission() {
  return (
    <div className="mission-container">
      {/* Image Animation - Fades in */}
      <motion.div
        className="mission-container-image"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
      >
        <img src={MissionImage} alt="nextcastle-mission" />
      </motion.div>

      <div className="mission-container-text">
        {/* Mission Section - Slides from left */}
        <motion.div
          className="mission"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <h2>Our Mission</h2>
          <p>
            It Is The Aim Of Founding Our Team To Make Nextcastle Energy Limited One Of The Lead Nigeria Services
            Companies In The World, Rending Different But Specialist Oil And Gas Services To The Upstream Sector.
          </p>
        </motion.div>

        {/* Vision Section - Slides from right */}
        <motion.div
          className="vision"
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <h2>Our Vision</h2>
          <p>
            It Is Our Vision To Provide Within The Frame System Of Nextcastle Energy Limited An Engineering Supermarket
            That Deals In Vast Specialist Services, Backed By Our Ability To Perform These Varied Functions Under One
            Roof, To The Satisfaction Of Our Clients.
          </p>
        </motion.div>

        {/* Core Values - Slides up */}
        <motion.div
          className="core-values"
          initial={{ y: 100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
        >
          <h2>Our Core Values</h2>
          <ul>
            <li>Excellence & Professionalism – We deliver top-tier energy solutions with precision and reliability.</li>
            <li>Safety & Sustainability – Protecting people and the environment is at the heart of our operations.</li>
            <li>Integrity & Transparency – We uphold ethical business practices and build trust through honesty.</li>
            <li>Innovation & Technology – Advancing energy solutions with cutting-edge technology.</li>
            <li>Sustainable Growth – Balancing economic progress with environmental responsibility.</li>
            <li>Client Commitment – Prioritizing stakeholder needs with value-driven solutions.</li>
          </ul>
        </motion.div>
      </div>
    </div>
  );
}

export default Mission;
